
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us/success",
      function () {
        return require("private-next-pages/contact-us/success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-us/success"])
      });
    }
  